import { rbInputStyle, rbSelectStyle } from "../reportBuilderTheme.js";

function btnStyle(c, { danger = false } = {}) {
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 30,
    padding: "0 10px",
    borderRadius: 7,
    border: `1px solid ${danger ? "#EF444444" : c.cardBdr}`,
    background: c.card,
    color: danger ? "#EF4444" : c.mid,
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    flexShrink: 0,
  };
}

export function createThemedQueryControls(c, A) {
  const focus = (e) => {
    e.currentTarget.style.borderColor = `${A}66`;
  };
  const blur = (e) => {
    e.currentTarget.style.borderColor = c.cardBdr;
  };

  return {
    fieldSelector: ({ options, value, handleOnChange, className }) => (
      <select
        className={className}
        value={value ?? ""}
        onChange={(e) => handleOnChange(e.target.value)}
        style={{ ...rbSelectStyle(c), minWidth: 130 }}
        onFocus={focus}
        onBlur={blur}
      >
        <option value="">Field…</option>
        {options.map((opt) => (
          <option key={opt.name} value={opt.name}>
            {opt.label}
          </option>
        ))}
      </select>
    ),

    operatorSelector: ({ options, value, handleOnChange, className }) => (
      <select
        className={className}
        value={value ?? ""}
        onChange={(e) => handleOnChange(e.target.value)}
        style={{ ...rbSelectStyle(c), minWidth: 120 }}
        onFocus={focus}
        onBlur={blur}
      >
        {options.map((opt) => (
          <option key={opt.name} value={opt.name}>
            {opt.label}
          </option>
        ))}
      </select>
    ),

    combinatorSelector: ({ options, value, handleOnChange, className }) => (
      <select
        className={className}
        value={value}
        onChange={(e) => handleOnChange(e.target.value)}
        style={{ ...rbSelectStyle(c), width: 88, fontWeight: 700, textTransform: "uppercase" }}
        onFocus={focus}
        onBlur={blur}
      >
        {options.map((opt) => (
          <option key={opt.name} value={opt.name}>
            {opt.label}
          </option>
        ))}
      </select>
    ),

    valueEditor: ({ value, handleOnChange, fieldData, operator, className, type }) => {
      if (operator === "null" || operator === "notNull") return null;
      const isExpr = operator === "expr" || operator === "case";
      const inputType = type === "number" || fieldData?.inputType === "number" ? "number" : "text";
      return (
        <input
          className={className}
          type={inputType}
          value={value ?? ""}
          onChange={(e) => handleOnChange(e.target.value)}
          placeholder={isExpr ? "e.g. distance_km / fuel_used" : operator === "between" ? "min, max" : operator === "in" ? "a, b, c" : "Value"}
          style={rbInputStyle(c, false, { mono: isExpr })}
          onFocus={focus}
          onBlur={blur}
        />
      );
    },

    notToggle: ({ checked, handleOnChange, className }) => (
      <label className={className} style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, color: c.mid, cursor: "pointer" }}>
        <input type="checkbox" checked={!!checked} onChange={(e) => handleOnChange(e.target.checked)} />
        NOT
      </label>
    ),

    addRuleAction: ({ handleOnClick, className }) => (
      <button type="button" className={className} onClick={handleOnClick} style={btnStyle(c)}>
        + Rule
      </button>
    ),

    addGroupAction: ({ handleOnClick, className }) => (
      <button type="button" className={className} onClick={handleOnClick} style={btnStyle(c)}>
        + Group
      </button>
    ),

    removeRuleAction: ({ handleOnClick, className }) => (
      <button type="button" className={className} onClick={handleOnClick} style={btnStyle(c, { danger: true })} aria-label="Remove rule">
        ×
      </button>
    ),

    removeGroupAction: ({ handleOnClick, className }) => (
      <button type="button" className={className} onClick={handleOnClick} style={btnStyle(c, { danger: true })} aria-label="Remove group">
        × Group
      </button>
    ),

    cloneRuleAction: ({ handleOnClick, className }) => (
      <button type="button" className={className} onClick={handleOnClick} style={btnStyle(c)} aria-label="Clone rule">
        ⧉
      </button>
    ),

    cloneGroupAction: ({ handleOnClick, className }) => (
      <button type="button" className={className} onClick={handleOnClick} style={btnStyle(c)} aria-label="Clone group">
        ⧉
      </button>
    ),
  };
}

export function queryBuilderShellStyle(c, dark) {
  return {
    padding: 12,
    borderRadius: 10,
    border: `1px solid ${c.divider}`,
    background: dark ? c.bg : c.hover,
    overflow: "auto",
  };
}

export const queryBuilderClassnames = {
  queryBuilder: "report-qb",
  ruleGroup: "report-qb-group",
  header: "report-qb-header",
  body: "report-qb-body",
  combinators: "report-qb-combinator",
  addRule: "report-qb-add-rule",
  addGroup: "report-qb-add-group",
  removeGroup: "report-qb-remove-group",
  removeRule: "report-qb-remove-rule",
  rule: "report-qb-rule",
  value: "report-qb-value",
};
